export const APP_ROUTES = {
  GENERAL: {
    LANDING: '/',
    HOME: '/home',
    POST_AUTHENTICATION: '/v3/post-authentication',
  },
};

export default APP_ROUTES;
